import type { Wrex } from '@lumapps/wrex/types';

import type { ImageElement } from '../components/blocks/Image';
import { IMAGE } from '../constants';

/** Create an image element */
export const createImage = (attributes: Wrex.ElementAttributes<ImageElement>): ImageElement => {
    return { type: IMAGE, ...attributes, children: [{ text: '' }] };
};
